<template lang="pug">
  .case-sample
    .case-sample-container
      .title {{ $t('参考案例') }}
      .case-sample-items
        .case-sample-item(
          v-for="(item, i) in data"
          @click="onClickCase(item.url)"
        )
          .img-background
            a
              img(
                :src="item.img"
              )
            i.iconfont.iconxiangxiadefuben
          .item-title {{ $t(item.title) }}
          .item-desc {{ $t(item.desc) }}
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    onClickCase (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="stylus">
.case-sample
  background #f6f7fb
  height 588px
  .case-sample-container
    width 1118px
    margin auto
    .title
      padding-top 75px
      font-size 32px
      color $black-title
      font-weight 600
      margin-bottom 45px
  .case-sample-items
    display flex
    align-items center
    justify-content space-between
  .case-sample-item
    width 367px
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    .img-background
      background #000
      width 357px
      height 221px
      position relative
      &:hover
        a
          opacity 0.9
        .iconfont
          opacity 1
    .iconfont
      opacity 0
      transform rotate(-90deg)
      display inline-block
      position absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
      width: 48px
      font-size: 48px
      margin: auto
      height: 48px
      color: #fff
    img
      width 357px
    .item-title
      color #478bca
      font-size 24px
      font-weight 600
      margin 20px 0 12px
    .item-desc
      width 357px
      color #595b74
      line-height 1.56
      font-size 18px
